import React, { useEffect, useState } from 'react';
import { getActiveTariffConfig, DEFAULT_CONFIG } from '../DELIVERY/utils/tarifaCalculator';

const DriverCommissionInfo = () => {
    const [pct, setPct] = useState(DEFAULT_CONFIG.platform_commission);

    useEffect(() => {
        let mounted = true;
        getActiveTariffConfig()
            .then(cfg => { if (mounted) setPct((cfg && cfg.platform_commission) || DEFAULT_CONFIG.platform_commission); })
            .catch(() => {});
        return () => { mounted = false; };
    }, []);

    return (
        <div data-testid="driver-commission-info" className="bg-gray-900 border border-gray-800 rounded-2xl p-4 mb-4">
            <div className="text-gray-400 text-[10px] uppercase font-bold tracking-wider mb-1">Tu comision</div>
            <div className="text-sm text-gray-200">
                Comision fija actual:{' '}
                <span data-testid="driver-commission-pct" className="font-black text-[var(--bry-accent)]">{pct}%</span>
            </div>
            <p className="text-xs text-gray-500 mt-1">
                Se descuenta del total del servicio. Cobras el monto neto que ves antes de aceptar.
            </p>
        </div>
    );
};

export default DriverCommissionInfo;
